import { render } from "./RedesignedSwitchComponent.vue?vue&type=template&id=6ed2a20e&scoped=true"
import script from "./RedesignedSwitchComponent.vue?vue&type=script&lang=js"
export * from "./RedesignedSwitchComponent.vue?vue&type=script&lang=js"

import "./RedesignedSwitchComponent.vue?vue&type=style&index=0&id=6ed2a20e&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed2a20e"]])

export default __exports__